/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import PropTypes from 'prop-types'
import { compose, mapProps, pure, setPropTypes } from 'recompose'
import photoShape from 'shapes/Photo'
import photoNavShape from 'shapes/PhotoNavigation'
import processPhoto from 'utils/processQueries/photo'
import processPhotoNavigation from 'utils/processQueries/photoNavigation'

export const Photo = compose(
  pure,
  mapProps(({ data: { photo, photos }, ...props }) => {
    return {
      ...props,
      photo: processPhoto(photo),
      photoNavigation: processPhotoNavigation(photos),
    }
  }),
  setPropTypes({
    className: PropTypes.string,
    photo: photoShape.single,
    photoNavigation: photoNavShape.list,
  })
)

export default Photo
